/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2023-06-12 15:10:48
 * @LastEditors: 张家彬
 * @LastEditTime: 2025-02-25 16:08:07
 */
//弹出提示框
import React, { useEffect, useState, FC, ReactNode } from "react"
import { Modal, Button, ModalProps } from 'antd'
import * as ReactDOM from 'react-dom';
import { useRequest } from "@umijs/max";


interface Props extends ModalProps {
    cancelText?: string | boolean
    okText?: string
    content: ReactNode | string
    onCancel?: () => void
    onOk?: (() => void | string) | (() => Promise<void>)
    delTipsModal?: () => void

}
interface Tips extends FC<Props> {
    config: (props: Props) => void
}
const TipsModal: Tips = (props) => {
    const { title, content, onOk, onCancel, okText = '确认', cancelText = '取消', ...custom } = props
    const [visible, setVisible] = useState(true)
    const [btnLoading, setBtnLoading] = useState(false)
    // const [visible, setVisible] = useState(false)
    const defaultCancel = () => {
        setVisible(false)
        onCancel && onCancel()

        //删除弹窗dom
        // const domTips = document.getElementById('tipsModal') as Element
        // ReactDOM.unmountComponentAtNode(domTips)
        // domTips?.parentElement?.removeChild(domTips)
    }
    const { run: asyncOnOk } = useRequest(onOk, {
        manual: true,
        onError() {
            setBtnLoading(false)
            setVisible(false)
        }
    })
    const defaultOk = async () => {
        //判断是否异步处理
        if (onOk) {
            setBtnLoading(true)
            await asyncOnOk()
            setBtnLoading(false)
            setVisible(false)
        }

    }

    //删除弹窗dom
    useEffect(() => {
        if (!visible) {
            custom?.delTipsModal && custom?.delTipsModal()
        }
    }, [visible])

    const configProps: ModalProps = {
        title,
        visible,
        maskClosable: false,
        styles: {
            body: { textAlign: 'center' },
            footer: {
                textAlign: 'center',
                gap: 30
            }
        },
        confirmLoading: btnLoading,
        onOk: defaultOk,
        onCancel: defaultCancel,
        okText,
        cancelText,
        // footer: [
        //     <div style={{ textAlign: 'center' }}>
        //         <Button type="primary" loading={custom.confirmLoading} onClick={() => { defaultOk() }}>{okText}</Button>
        //         {cancelText !== false && <Button style={{ marginLeft: 40 }} onClick={() => defaultCancel()}>{cancelText}</Button>}
        //     </div>
        // ],
        ...custom
    }

    return (
        <Modal
            {...configProps}

        >
            <p>{content as string}</p>
        </Modal>
    )
}

TipsModal.config = (props: Props): { delTipsModal: () => void } => {
    const div = document.createElement("div");
    div.id = 'tipsModal'
    //删除弹窗dom
    const delTipsModal = () => {
        ReactDOM.unmountComponentAtNode(div)
    }
    ReactDOM.render(
        <TipsModal {...props} delTipsModal={delTipsModal} />, div)
    return {
        delTipsModal
    }
}

export type TipsMoadlConfigProps = Props

export const TipsMoadlConfig = TipsModal.config

export default TipsModal